import React, { Component } from "react";
import "./Addmedicine.css";
import * as XLSX from "xlsx";
import dateFormat from "dateformat";
import axiosInstance from "../../api/axiosInstance";
import { apiurl } from "../../App";
import Cookies from "js-cookie";
import { initEncryptionSession } from "../../encryptionSession";
import { encryptData } from "../Crypto_Helpers/cryptoHelper";
import {
  HiOutlineX,
  HiOutlineCloudUpload,
  HiOutlineDocumentDownload,
  HiOutlinePlusCircle,
  HiOutlineCheck,
  HiOutlineInformationCircle,
} from "react-icons/hi";

class AddmedicineModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "excel", // 'excel' | 'manual'
      validationErrors: "",
      isDragging: false,
      selectedFile: null,
      isSubmitting: false,
      // Manual form fields
      manualForm: {
        medicine_name: "",
        dosage: "",
        stock: "",
        per_stock_price: "",
        per_tablet_price: "",
        tax: "0",
        mfg_date: "",
        exp_date: "",
      },
      formErrors: {},
    };
  }

  convertExcelDate = (excelDate, is1904 = false) => {
    if (!excelDate) return "";
    if (typeof excelDate === "string") {
      const parsed = new Date(excelDate);
      if (!isNaN(parsed.getTime())) {
        return dateFormat(parsed, "yyyy-mm-dd");
      }
      return excelDate;
    }
    const baseDate = is1904 ? new Date(1904, 0, 1) : new Date(1900, 0, 1);
    const daysOffset = is1904 ? excelDate : excelDate - 2;
    baseDate.setDate(baseDate.getDate() + daysOffset);
    const day = String(baseDate.getDate()).padStart(2, "0");
    const month = String(baseDate.getMonth() + 1).padStart(2, "0");
    const year = baseDate.getFullYear();
    return `${year}-${month}-${day}`;
  };

  handleDownloadExcel = (e) => {
    if (e) e.preventDefault();
    const headers = [
      "Medicine_Name",
      "Dosage",
      "Stock",
      "Per_Stock_Price",
      "Tax",
      "Mfg_Date",
      "Exp_Date",
      "Per_Tablet_Price",
    ];
    const sampleRows = [
      ["Paracetamol", "500mg", 100, 20.0, 5, "2025-01-01", "2027-01-01", 2.0],
      ["Amoxicillin", "250mg", 50, 45.0, 5, "2025-02-15", "2026-12-31", 4.5],
      ["Cetirizine", "10mg", 200, 15.0, 0, "2025-03-10", "2028-03-10", 1.5],
    ];

    const worksheet = XLSX.utils.aoa_to_sheet([headers, ...sampleRows]);
    worksheet["!cols"] = [
      { wch: 22 },
      { wch: 12 },
      { wch: 10 },
      { wch: 16 },
      { wch: 8 },
      { wch: 14 },
      { wch: 14 },
      { wch: 18 },
    ];
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "MedicineInventory");
    XLSX.writeFile(
      workbook,
      `medicine_template_${dateFormat(new Date(), "dd-mmm-yy")}.xlsx`
    );
  };

  handleFileSelect = (file) => {
    if (!file) return;
    const allowedExtensions = ["xlsx", "xls"];
    const fileExtension = file.name.split(".").pop().toLowerCase();

    if (!allowedExtensions.includes(fileExtension)) {
      this.setState({
        validationErrors: "Invalid file format. Please upload a valid .xlsx or .xls Excel sheet.",
        selectedFile: null,
      });
      return;
    }

    this.setState({
      selectedFile: file,
      validationErrors: "",
    });
  };

  handleUploadExcel = async () => {
    const { selectedFile } = this.state;
    if (!selectedFile) {
      this.setState({ validationErrors: "Please select an Excel file to upload." });
      return;
    }

    this.setState({ isSubmitting: true, validationErrors: "" });
    try {
      const aesKey = await initEncryptionSession();
      const reader = new FileReader();

      reader.onload = async (e) => {
        try {
          const data = new Uint8Array(e.target.result);
          const workbook = XLSX.read(data, { type: "array" });
          const sheetName = workbook.SheetNames[0];
          const worksheet = workbook.Sheets[sheetName];
          const jsonData = XLSX.utils.sheet_to_json(worksheet);

          if (!jsonData || jsonData.length === 0) {
            this.setState({
              isSubmitting: false,
              validationErrors: "The uploaded file contains no data rows. Please use the template.",
            });
            return;
          }

          const updatedData = jsonData.map((item) => ({
            ...item,
            Mfg_Date: this.convertExcelDate(item.Mfg_Date || item.mfg_date),
            Exp_Date: this.convertExcelDate(item.Exp_Date || item.exp_date),
          }));

          const pharmId =
            Cookies.get("pharmacy_id") ||
            Cookies.get("vendorId") ||
            localStorage.getItem("pharmacy_id") ||
            0;

          const medicineRateApiData = {
            Pharmacy_id: Number(pharmId) || 0,
            created_by: 19,
            created_on: dateFormat(new Date(), "yyyy-mm-dd hh:MM:ss"),
            modified_by: 19,
            modified_on: dateFormat(new Date(), "yyyy-mm-dd hh:MM:ss"),
            xlDataList: JSON.stringify(updatedData),
          };

          let requestPayload = medicineRateApiData;
          if (aesKey) {
            try {
              const encrypted = await encryptData(medicineRateApiData, aesKey);
              requestPayload = { objects: encrypted };
            } catch (err) {
              requestPayload = medicineRateApiData;
            }
          }

          const response = await axiosInstance.post(
            apiurl + "pharmacy/insert_mas_pharm_medicine_rate",
            requestPayload
          );

          this.setState({ isSubmitting: false });
          if (response.data && response.data.msg !== "Failed" && response.data.status !== 0) {
            this.props.handleopenSuccess("Medicines imported successfully!", true);
            this.props.onClose();
          } else {
            this.setState({
              validationErrors: response.data.msg || "Failed to import medicines.",
            });
          }
        } catch (err) {
          console.error("Excel parse/submit error:", err);
          this.setState({
            isSubmitting: false,
            validationErrors: "Failed to process Excel file. Please verify columns match the template.",
          });
        }
      };

      reader.readAsArrayBuffer(selectedFile);
    } catch (err) {
      console.error("Upload error:", err);
      this.setState({ isSubmitting: false, validationErrors: "Upload failed. Please try again." });
    }
  };

  handleManualSubmit = async (e) => {
    if (e) e.preventDefault();
    const { manualForm } = this.state;
    const errors = {};

    if (!manualForm.medicine_name.trim()) errors.medicine_name = "Medicine name is required";
    if (!manualForm.stock || Number(manualForm.stock) <= 0) errors.stock = "Valid stock is required";
    if (!manualForm.per_stock_price || Number(manualForm.per_stock_price) <= 0)
      errors.per_stock_price = "Stock price is required";
    if (!manualForm.per_tablet_price || Number(manualForm.per_tablet_price) <= 0)
      errors.per_tablet_price = "Per tablet price is required";
    if (!manualForm.mfg_date) errors.mfg_date = "MFG date is required";
    if (!manualForm.exp_date) errors.exp_date = "EXP date is required";

    if (Object.keys(errors).length > 0) {
      this.setState({ formErrors: errors });
      return;
    }

    this.setState({ isSubmitting: true, formErrors: {} });
    try {
      const aesKey = await initEncryptionSession();
      const pharmId =
        Cookies.get("pharmacy_id") ||
        Cookies.get("vendorId") ||
        localStorage.getItem("pharmacy_id") ||
        0;

      const singleMedicineRecord = [
        {
          Medicine_Name: manualForm.medicine_name.trim(),
          Dosage: manualForm.dosage.trim(),
          Stock: Number(manualForm.stock),
          Per_Stock_Price: Number(manualForm.per_stock_price),
          Tax: Number(manualForm.tax) || 0,
          Mfg_Date: manualForm.mfg_date,
          Exp_Date: manualForm.exp_date,
          Per_Tablet_Price: Number(manualForm.per_tablet_price),
        },
      ];

      const medicineRateApiData = {
        Pharmacy_id: Number(pharmId) || 0,
        created_by: 19,
        created_on: dateFormat(new Date(), "yyyy-mm-dd hh:MM:ss"),
        modified_by: 19,
        modified_on: dateFormat(new Date(), "yyyy-mm-dd hh:MM:ss"),
        xlDataList: JSON.stringify(singleMedicineRecord),
      };

      let requestPayload = medicineRateApiData;
      if (aesKey) {
        try {
          const encrypted = await encryptData(medicineRateApiData, aesKey);
          requestPayload = { objects: encrypted };
        } catch (err) {
          requestPayload = medicineRateApiData;
        }
      }

      const response = await axiosInstance.post(
        apiurl + "pharmacy/insert_mas_pharm_medicine_rate",
        requestPayload
      );

      this.setState({ isSubmitting: false });
      if (response.data && response.data.msg !== "Failed" && response.data.status !== 0) {
        this.props.handleopenSuccess("Medicine added successfully!", true);
        this.props.onClose();
      } else {
        this.setState({
          validationErrors: response.data.msg || "Failed to add medicine.",
        });
      }
    } catch (err) {
      console.error("Manual add medicine error:", err);
      this.setState({
        isSubmitting: false,
        validationErrors: "Failed to add medicine. Please try again.",
      });
    }
  };

  render() {
    const { onClose } = this.props;
    const { activeTab, validationErrors, selectedFile, isDragging, isSubmitting, manualForm, formErrors } =
      this.state;

    return (
      <div
        className="fixed inset-y-0 right-0 left-0 z-50 bg-slate-900/40 backdrop-blur-xs flex items-center justify-center p-4 sm:p-6"
        onClick={onClose}
      >
        <div
          className="bg-white rounded-xl shadow-2xl border border-slate-100 w-full max-w-lg overflow-hidden flex flex-col max-h-[90vh] animate-scaleUp"
          onClick={(e) => e.stopPropagation()}
        >
          {/* Modal Header */}
          <div className="flex items-center justify-between px-5 py-3.5 border-b border-slate-100 bg-white sticky top-0 z-10">
            <div>
              <h3 className="text-lg sm:text-xl font-bold text-slate-900 tracking-tight leading-none mb-1">
                Add <span className="text-teal-600">Medicine</span>
              </h3>
              <p className="text-xs text-slate-500 font-medium">
                Import bulk medicine inventory or add single records manually
              </p>
            </div>
            <button
              type="button"
              onClick={onClose}
              className="w-7 h-7 rounded-lg bg-red-50 text-red-500 hover:bg-red-500 hover:text-white flex items-center justify-center transition-all duration-200 cursor-pointer shadow-2xs"
            >
              <HiOutlineX size={16} />
            </button>
          </div>

          {/* Mode Switcher Tabs */}
          <div className="px-5 pt-3 pb-2 bg-slate-50/70 border-b border-slate-100 flex gap-2">
            <button
              type="button"
              onClick={() => this.setState({ activeTab: "excel", validationErrors: "" })}
              className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all cursor-pointer ${
                activeTab === "excel"
                  ? "bg-teal-600 text-white shadow-xs"
                  : "bg-white text-slate-600 hover:bg-slate-100 border border-slate-200"
              }`}
            >
              <HiOutlineCloudUpload size={16} />
              Bulk Excel Import
            </button>
            <button
              type="button"
              onClick={() => this.setState({ activeTab: "manual", validationErrors: "" })}
              className={`flex items-center gap-1.5 px-3.5 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider transition-all cursor-pointer ${
                activeTab === "manual"
                  ? "bg-teal-600 text-white shadow-xs"
                  : "bg-white text-slate-600 hover:bg-slate-100 border border-slate-200"
              }`}
            >
              <HiOutlinePlusCircle size={16} />
              Single Medicine Form
            </button>
          </div>

          {/* Modal Body */}
          <div className="flex-1 overflow-y-auto p-5 space-y-4">
            {validationErrors && (
              <div className="flex items-center gap-2.5 p-3 rounded-xl bg-red-50 border border-red-200 text-red-700 text-xs font-medium">
                <HiOutlineInformationCircle size={18} className="shrink-0 text-red-500" />
                <span>{validationErrors}</span>
              </div>
            )}

            {/* TAB 1: BULK EXCEL UPLOAD */}
            {activeTab === "excel" && (
              <div className="space-y-4">
                {/* Drag and drop zone */}
                <div
                  onDragOver={(e) => {
                    e.preventDefault();
                    this.setState({ isDragging: true });
                  }}
                  onDragLeave={() => this.setState({ isDragging: false })}
                  onDrop={(e) => {
                    e.preventDefault();
                    this.setState({ isDragging: false });
                    if (e.dataTransfer.files && e.dataTransfer.files.length > 0) {
                      this.handleFileSelect(e.dataTransfer.files[0]);
                    }
                  }}
                  className={`border-2 border-dashed rounded-2xl p-5 text-center transition-all flex flex-col items-center justify-center gap-3 ${
                    isDragging
                      ? "border-teal-500 bg-teal-50/50 scale-[0.99]"
                      : "border-slate-200 bg-slate-50/50 hover:border-teal-400 hover:bg-teal-50/20"
                  }`}
                >
                  <div className="w-11 h-11 rounded-xl bg-teal-100/70 text-teal-600 flex items-center justify-center shadow-2xs">
                    <HiOutlineCloudUpload size={24} />
                  </div>

                  <div>
                    <h4 className="text-xs sm:text-sm font-bold text-slate-800">
                      Drag & Drop your Excel inventory file here
                    </h4>
                    <p className="text-xs text-slate-500 mt-0.5">
                      Supports <span className="font-semibold">.xlsx, .xls</span> files with medicine rates
                    </p>
                  </div>

                  <div className="flex items-center gap-2">
                    <label
                      htmlFor="excelUploadInput"
                      className="px-4 py-1.5 rounded-lg bg-teal-600 hover:bg-teal-700 text-white font-bold text-xs uppercase tracking-wider cursor-pointer transition-all shadow-xs active:scale-95"
                    >
                      Browse File
                    </label>
                    <input
                      type="file"
                      id="excelUploadInput"
                      accept=".xlsx,.xls"
                      className="hidden"
                      onChange={(e) => {
                        if (e.target.files && e.target.files.length > 0) {
                          this.handleFileSelect(e.target.files[0]);
                        }
                      }}
                    />
                  </div>

                  {selectedFile && (
                    <div className="mt-1 flex items-center gap-1.5 px-3 py-1.5 bg-teal-100/50 text-teal-800 rounded-lg border border-teal-200 text-xs font-bold animate-fadeIn">
                      <HiOutlineCheck size={16} className="text-teal-600" />
                      <span>{selectedFile.name}</span>
                      <span className="text-teal-600 font-normal">
                        ({(selectedFile.size / 1024).toFixed(1)} KB)
                      </span>
                    </div>
                  )}
                </div>

                {/* Template Download Banner */}
                <div className="flex flex-col sm:flex-row items-center justify-between gap-3 p-3 rounded-xl bg-slate-100/80 border border-slate-200">
                  <div className="flex items-center gap-2.5">
                    <div className="w-8 h-8 rounded-lg bg-teal-600 text-white flex items-center justify-center shrink-0">
                      <HiOutlineDocumentDownload size={18} />
                    </div>
                    <div>
                      <p className="text-xs font-bold text-slate-800">Need the standard Excel format?</p>
                      <p className="text-xs text-slate-500 font-medium">
                        Download pre-formatted template with sample medicine rows
                      </p>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={this.handleDownloadExcel}
                    className="px-3 py-1.5 bg-white hover:bg-teal-50 text-teal-700 border border-teal-200 hover:border-teal-400 font-bold text-xs rounded-lg transition-all shrink-0 cursor-pointer shadow-2xs"
                  >
                    Download Template
                  </button>
                </div>
              </div>
            )}

            {/* TAB 2: MANUAL SINGLE MEDICINE ADD */}
            {activeTab === "manual" && (
              <form onSubmit={this.handleManualSubmit} className="space-y-3">
                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {/* Medicine Name */}
                  <div className="space-y-1 sm:col-span-2">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      Medicine Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. Paracetamol"
                      value={manualForm.medicine_name}
                      onChange={(e) =>
                        this.setState({
                          manualForm: { ...manualForm, medicine_name: e.target.value },
                          formErrors: { ...formErrors, medicine_name: "" },
                        })
                      }
                      className={`w-full px-3 py-1.5 rounded-lg border ${
                        formErrors.medicine_name ? "border-red-500 bg-red-50/10" : "border-slate-300 bg-slate-50/40"
                      } focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all`}
                    />
                    {formErrors.medicine_name && (
                      <p className="text-xs text-red-500 font-bold ml-1">{formErrors.medicine_name}</p>
                    )}
                  </div>

                  {/* Dosage */}
                  <div className="space-y-1">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      Dosage / Strength
                    </label>
                    <input
                      type="text"
                      placeholder="e.g. 500mg or 10ml"
                      value={manualForm.dosage}
                      onChange={(e) =>
                        this.setState({
                          manualForm: { ...manualForm, dosage: e.target.value },
                        })
                      }
                      className="w-full px-3 py-1.5 rounded-lg border border-slate-300 bg-slate-50/40 focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all"
                    />
                  </div>

                  {/* Stock Quantity */}
                  <div className="space-y-1">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      Stock Quantity <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      min="0"
                      placeholder="e.g. 100"
                      value={manualForm.stock}
                      onChange={(e) => {
                        const newStock = e.target.value;
                        const stockNum = Number(newStock);
                        const priceNum = Number(manualForm.per_stock_price);
                        const autoTabletPrice = (stockNum > 0 && priceNum > 0) ? (priceNum / stockNum).toFixed(2) : manualForm.per_tablet_price;
                        this.setState({
                          manualForm: { ...manualForm, stock: newStock, per_tablet_price: autoTabletPrice },
                          formErrors: { ...formErrors, stock: "" },
                        });
                      }}
                      className={`w-full px-3 py-1.5 rounded-lg border ${
                        formErrors.stock ? "border-red-500 bg-red-50/10" : "border-slate-300 bg-slate-50/40"
                      } focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all`}
                    />
                    {formErrors.stock && (
                      <p className="text-xs text-red-500 font-bold ml-1">{formErrors.stock}</p>
                    )}
                  </div>

                  {/* Per Stock Price */}
                  <div className="space-y-1">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      Per Stock / Strip Price (₹) <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="e.g. 50.00"
                      value={manualForm.per_stock_price}
                      onChange={(e) => {
                        const newStockPrice = e.target.value;
                        const stock = Number(manualForm.stock);
                        const stockPrice = Number(newStockPrice);
                        const autoTabletPrice = (stock > 0 && stockPrice > 0) ? (stockPrice / stock).toFixed(2) : manualForm.per_tablet_price;
                        this.setState({
                          manualForm: { ...manualForm, per_stock_price: newStockPrice, per_tablet_price: autoTabletPrice },
                          formErrors: { ...formErrors, per_stock_price: "" },
                        });
                      }}
                      className={`w-full px-3 py-1.5 rounded-lg border ${
                        formErrors.per_stock_price ? "border-red-500 bg-red-50/10" : "border-slate-300 bg-slate-50/40"
                      } focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all`}
                    />
                    {formErrors.per_stock_price && (
                      <p className="text-xs text-red-500 font-bold ml-1">{formErrors.per_stock_price}</p>
                    )}
                  </div>

                  {/* Per Tablet Price */}
                  <div className="space-y-1">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      Per Tablet Unit Price ({"₹"}) <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      min="0"
                      placeholder="e.g. 5.00"
                      value={manualForm.per_tablet_price}
                      onChange={(e) =>
                        this.setState({
                          manualForm: { ...manualForm, per_tablet_price: e.target.value },
                          formErrors: { ...formErrors, per_tablet_price: "" },
                        })
                      }
                      className={`w-full px-3 py-1.5 rounded-lg border ${
                        formErrors.per_tablet_price ? "border-red-500 bg-red-50/10" : "border-slate-300 bg-slate-50/40"
                      } focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all`}
                    />
                    {formErrors.per_tablet_price && (
                      <p className="text-xs text-red-500 font-bold ml-1">{formErrors.per_tablet_price}</p>
                    )}
                  </div>

                  {/* Manufacturing Date */}
                  <div className="space-y-1">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      MFG Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      value={manualForm.mfg_date}
                      onChange={(e) =>
                        this.setState({
                          manualForm: { ...manualForm, mfg_date: e.target.value },
                          formErrors: { ...formErrors, mfg_date: "" },
                        })
                      }
                      className={`w-full px-3 py-1.5 rounded-lg border ${
                        formErrors.mfg_date ? "border-red-500 bg-red-50/10" : "border-slate-300 bg-slate-50/40"
                      } focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all`}
                    />
                    {formErrors.mfg_date && (
                      <p className="text-xs text-red-500 font-bold ml-1">{formErrors.mfg_date}</p>
                    )}
                  </div>

                  {/* Expiry Date */}
                  <div className="space-y-1">
                    <label className="block text-xs font-bold text-slate-700 uppercase tracking-wider">
                      EXP Date <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="date"
                      value={manualForm.exp_date}
                      onChange={(e) =>
                        this.setState({
                          manualForm: { ...manualForm, exp_date: e.target.value },
                          formErrors: { ...formErrors, exp_date: "" },
                        })
                      }
                      className={`w-full px-3 py-1.5 rounded-lg border ${
                        formErrors.exp_date ? "border-red-500 bg-red-50/10" : "border-slate-300 bg-slate-50/40"
                      } focus:border-teal-600 focus:bg-white text-xs font-medium outline-none transition-all`}
                    />
                    {formErrors.exp_date && (
                      <p className="text-xs text-red-500 font-bold ml-1">{formErrors.exp_date}</p>
                    )}
                  </div>
                </div>
              </form>
            )}
          </div>

          {/* Modal Footer */}
          <div className="px-5 py-3 border-t border-slate-100 bg-slate-50 flex items-center justify-end gap-2">
            <button
              type="button"
              onClick={onClose}
              disabled={isSubmitting}
              className="px-4 py-1.5 rounded-lg border border-slate-300 text-slate-700 hover:bg-slate-200 text-xs font-bold uppercase tracking-wider transition-all cursor-pointer"
            >
              Cancel
            </button>

            {activeTab === "excel" ? (
              <button
                type="button"
                onClick={this.handleUploadExcel}
                disabled={isSubmitting || !selectedFile}
                className={`px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider text-white transition-all shadow-xs flex items-center gap-1.5 cursor-pointer ${
                  isSubmitting || !selectedFile
                    ? "bg-slate-300 cursor-not-allowed shadow-none"
                    : "bg-teal-600 hover:bg-teal-700 active:scale-95"
                }`}
              >
                {isSubmitting ? (
                  <>
                    <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Uploading...
                  </>
                ) : (
                  <>
                    <HiOutlineCloudUpload size={15} />
                    Import Excel Data
                  </>
                )}
              </button>
            ) : (
              <button
                type="button"
                onClick={this.handleManualSubmit}
                disabled={isSubmitting}
                className="px-4 py-1.5 rounded-lg text-xs font-bold uppercase tracking-wider text-white bg-teal-600 hover:bg-teal-700 transition-all shadow-xs active:scale-95 flex items-center gap-1.5 cursor-pointer"
              >
                {isSubmitting ? (
                  <>
                    <div className="w-3 h-3 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    Saving...
                  </>
                ) : (
                  <>
                    <HiOutlineCheck size={15} />
                    Save Medicine
                  </>
                )}
              </button>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default AddmedicineModal;
